<template>
    <fieldset class="m-form-select">
        <select
                class="m-form-select-select"
                :class="{'is-show':value}"
                :name="selectName"
                :id="selectName"
                v-model="updateSelect"
                @blur="blurEvent()"
                data-jest="form-select"
        >
            <option value="" disabled>{{ placeholder }}</option>
            <option v-for="(option, index) in optionList" :value="option.label" :key="`select-list_${index}`" :data-jest="`select-list_${index}`">
                {{ option.label }}
            </option>
        </select>
        <div v-if="!value" class="m-form-select-placeholder">
            <span class="m-form-select-text">{{ placeholder }}</span>
        </div>
    </fieldset>
</template>

<script>
    export default {
        name: "FormSelect",
        props: {
            /**
             * プレースホルダーテキスト
             */
            placeholder: {
                type:  String,
                required: true
            },
            /**
             * id属性
             */
            selectName: {
                type:  String,
                required: true
            },
            /**
             * 選択したオプションの値
             */
            value: {
                type:  String,
                required: true
            },
            /**
             * オプション
             */
            optionList: {
                type:  Array,
                required: true,
            },
            /**
             * blur時に実行する関数
             */
            blurEvent: {
                type: Function,
                required: false,
                default: function() {
                    return 'Default function'
                }
            }
        },
        emits: ['update:modelValue'],
        computed: {
            updateSelect: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @use '../../../scss/v2/base/variables';
    // 基本の余白
    $grid-base: 4.27vw; // 375px幅に対して16px
    $grid-consistent: $grid-base * 0.5;// 375px幅に対して8px
    .m-form-select {
        position: relative;
        &:after {
            width: 24px;
            height: 24px;
            content: '';
            display: block;
            position: absolute;
            background: url('/img/v2/icon/arrow/icon_arrow_gray.svg');
            background-size: contain;
            right: 16px;
            top: 50%;
            margin-top: -12px;
            pointer-events: none;
        }
        &-select {
            width: 100%;
            opacity: variables.$opacity-0;
            margin-bottom: 0;
            line-height: 1.4;
            &.is-show {
                opacity: variables.$opacity-100;
            }
            &:focus {
                & + .m-form-select-placeholder {
                    border: 1px solid variables.$color-pictlink-pink;
                }
            }
        }
        // placeholderを作るためselect欄を擬似的に作る
        &-placeholder {
            pointer-events: none;
            position: absolute;
            display: block;
            width: 100%;
            top: 0;
            box-sizing: border-box;
            padding: 10px $grid-consistent*2;
            margin-bottom: $grid-consistent * 0.5;
            border: 1px solid variables.$color-pictlink-fog-25;
            border-radius: 6px;
        }
        // placeholderのグレーテキスト
        &-text {
            font-size: 1.4rem;
            line-height: 1.4;
            color: rgba(variables.$color-pictlink-black-30, variables.$opacity-50);
        }
    }
</style>
